import './css/style.css';
import { registerSW } from 'virtual:pwa-register';
import { startApp } from './js/app.js';

registerSW({ immediate: true });
import {
  ConfigError,
  getSession,
  onAuthStateChange,
} from './js/supabase-client.js';
import { renderLogin } from './js/views/login.js';
import { renderInviteAuth } from './js/views/invite-auth.js';
import { getPendingInviteToken, tryAcceptPendingInvite } from './js/trip-invites.js';
import { tearDownRealtime } from './js/trip-context.js';
import { initConnectivityMonitoring } from './js/utils/connectivity.js';

const app = document.getElementById('app');
let sessionActive = false;

function inviteTokenFromHash() {
  return location.hash.match(/^#\/invite\/([^/?#]+)/)?.[1] ?? null;
}

function renderConfigError(message) {
  app.innerHTML = `
    <main class="app-loading">
      <h1>Metis</h1>
      <p class="config-error">${message}</p>
      <p class="config-hint">Segui <code>docs/SETUP.md</code> — Passo 3 (URL e anon key).</p>
    </main>
  `;
}

function renderLoading() {
  app.innerHTML = `
    <main class="app-loading">
      <h1>Metis</h1>
      <p>Caricamento…</p>
    </main>
  `;
}

function showLogin() {
  sessionActive = false;
  tearDownRealtime();
  const token = inviteTokenFromHash() || getPendingInviteToken();
  if (token) {
    renderInviteAuth(app, token, () => {
      /* session handled by onAuthStateChange */
    });
    return;
  }
  renderLogin(app, () => {
    /* session handled by onAuthStateChange */
  });
}

async function showApp() {
  if (sessionActive) return;
  sessionActive = true;

  try {
    const tripId = await tryAcceptPendingInvite();
    if (tripId) {
      location.hash = `#/trip/${tripId}/days`;
    }
  } catch (error) {
    alert(error.message ?? 'Impossibile accettare l\'invito.');
  }

  startApp(app);
}

async function init() {
  if (!app) return;
  initConnectivityMonitoring();
  renderLoading();

  try {
    const session = await getSession();
    if (session) {
      showApp();
    } else {
      showLogin();
    }

    onAuthStateChange((nextSession) => {
      if (nextSession) {
        showApp();
      } else {
        showLogin();
      }
    });
  } catch (error) {
    if (error instanceof ConfigError) {
      renderConfigError(error.message);
      return;
    }
    app.innerHTML = `
      <main class="app-loading">
        <h1>Metis</h1>
        <p class="status-error">${error.message}</p>
      </main>
    `;
  }
}

init();
